import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";
    module.controller('ForecastMarketDumpCtrl', ['forecastMarketDump', '$scope', '$state', angularServicesNames.$translate, AgGridService.componentName, ForecastMarketDumpCtrl]);

    function ForecastMarketDumpCtrl(
        this: $TSFixMe,
        forecastMarketDump: $TSFixMe,
        $scope: $TSFixMe,
        $state: ng.ui.IStateService,
        $translate: ng.translate.ITranslateService,
        agGridService: AgGridService
    ) {
        const $ctrl = this;
        $scope.forecastMarketDump = forecastMarketDump;
        $scope.source = 'forecastMarketDumpSource';

        $ctrl.goToReferenceMarket = function () {
            $state.go('market.edit-ims', {
                id: $scope.forecastMarketDump.marketId
            });
        }

        function refreshGrid() {
            $ctrl.gridApi.setRowData($scope.forecastMarketDump.newProducts);
        }

        $ctrl.newProdcutsGridOptions = {
            columnDefs: [{
                    field: 'oracleIndex',
                    headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.ORACLE_INDEX")
                },
                {
                    field: 'sku',
                    headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.SKU")
                },
                {
                    field: 'brand',
                    headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.BRAND")
                }
            ],
            angularCompileRows: true,
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            enableFilter: false,
            animateRows: true,
            pagination: true,
            paginationPageSize: 10,
            localeTextFunc: agGridService.transalteFunc,
            suppressHorizontalScroll: true,
            domLayout: 'autoHeight',
            onGridReady: (config: $TSFixMe) => {
                $ctrl.gridApi = config.api;
                config.api.sizeColumnsToFit();
                refreshGrid();
            },
            onGridSizeChanged: (config: $TSFixMe) => {
                config.api.sizeColumnsToFit();
            }
        };

    }

})(angular.module('topline.modules'));